import { getDurationObj } from '@umu/umu-util';
import { lang } from '@umu/ukit-lang';
import React from 'react';
import { components } from 'common';
const { If } = components;
import { bizUtils } from 'businessCommon';
const { LANG } = bizUtils;

export const RenderDuration = ({ duration }: { duration: string | number }) => {
    const time = Number(duration || '0');
    if (!time) {
        return null;
    }
    const dateObj = getDurationObj(time || 0);
    return (
        <If condition={dateObj.hours > 0 || dateObj.minutes > 0}>
            <>
                <If condition={dateObj.hours > 0}>
                    <>{lang('{$0{0=小时,1=小时}}', dateObj.hours)}</>
                </If>

                <If condition={dateObj.minutes > 0}>
                    <>
                        <If condition={LANG !== 'CN'}>
                            <>{` ${lang('{$0{0=分钟,1=分钟}}', dateObj.minutes)}`}</>
                        </If>
                        <If condition={LANG === 'CN'}>
                            <>{lang('{$0{0=分钟,1=分钟}}', dateObj.minutes)}</>
                        </If>
                    </>
                </If>
            </>
        </If>
    );
};
